<template>
  <div>
    <el-dialog
      :visible="true"
      width="1000px"
      :close-on-click-modal="false"
      :show-close="false"
      :modal-append-to-body="false"
    >
      <div class="disaster-dialog">
        <div class="disaster-dialog-header">
          <p class="disaster-dialog__title">
            【{{ $t('DisasterAlert.Title') }}】​{{ disasterAlertData?.Forecast?.CardTitle }}
          </p>
          <p class="disaster-dialog__expired">
            {{ `（${$t('DisasterAlert.ExpiredTime')} ${disasterExpired}）` }}
          </p>
        </div>
        <div class="disaster-dialog-body">
          <div
            class="disaster-dialog__info"
            v-html="disasterAlertData?.Forecast?.AdminInformation"
          ></div>
          <div class="disaster-image">
            <div class="disaster-image-header">
              <img
                class="disaster-image__image"
                :src="disasterAlertData?.Forecast?.Icon"
                alt=""
              />
              <div>
                <p class="disaster-image__title">
                  {{ disasterAlertData?.Forecast?.CardTitle }}
                </p>
                <p class="disaster-image__community">
                  {{ disasterAlertData?.CommunityName }}
                </p>
              </div>
            </div>
            <div class="disaster-image-body">
              <p>{{ disasterAlertData?.Forecast?.CardContent }}</p>
              <p class="disaster-image__expired">
                {{ `${$t('DisasterAlert.ExpiredTime')} ${disasterExpired}` }}
              </p>
              <div class="disaster-chart">
                <div class="chart-area">
                  <canvas ref="chartCanvas"></canvas>
                  <div class="legend-area">
                    <div class="legend-ticks">
                      <div class="legend-colors">
                        <span
                          v-for="tick in disasterAlertData?.Forecast?.Tick"
                          :key="tick.Value"
                          class="legend-color"
                          :style="{ backgroundColor: tick.Color }"
                        />
                      </div>
                      <div class="legend-labels">
                        <span
                          v-for="tick in disasterAlertData?.Forecast?.Tick"
                          :key="tick.Value + '-label'"
                          class="legend-label"
                        >{{ tick.Label }}</span>
                        <span class="legend-unit">({{ disasterAlertData?.Forecast?.Unit }})</span>
                      </div>
                    </div>
                    <div class="disaster-chart__logo">
                      <img
                        :src="disasterAlertData?.Forecast?.Logo"
                        alt="logo"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-button
          type="primary"
          class="disaster-dialog__btn"
          @click="closeDialog"
        >
          {{ $t('DisasterAlert.Close') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  Chart,
  CategoryScale,
  LinearScale,
  BarController,
  BarElement,
  Tooltip
} from 'chart.js'
import dayjs from 'dayjs'
Chart.register(CategoryScale, LinearScale, BarController, BarElement, Tooltip)
export default {
  name: 'DisasterDialog',
  props: {
    disasterAlertData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      chartInstance: null
    }
  },
  computed: {
    disasterExpired () {
      return (
        dayjs(this.disasterAlertData?.ExpiredTime).format('YYYY/MM/DD HH:mm') ||
        ''
      )
    }
  },
  mounted () {
    const legendWidth = 150 / this.disasterAlertData.Forecast.Tick.length
    document.documentElement.style.setProperty(
      '--legend-width',
      `${legendWidth}px`
    )
    this.$nextTick(() => {
      this.renderChart()
    })
  },
  methods: {
    closeDialog () {
      this.$emit('close')
    },
    async renderChart () {
      if (this.chartInstance) {
        this.chartInstance.destroy()
      }
      const ctx = this.$refs.chartCanvas.getContext('2d')
      // 取得tick顏色依照value分段
      const getBarColor = (value) => {
        // 依照tick區間設定顏色
        for (
          let i = this.disasterAlertData.Forecast.Tick.length - 1;
          i >= 0;
          i--
        ) {
          if (value >= this.disasterAlertData.Forecast.Tick[i].Value) {
            return this.disasterAlertData.Forecast.Tick[i].Color
          }
        }
        return '#BDBDBD'
      }
      const barColors = this.disasterAlertData.Forecast.Data.map((item) =>
        getBarColor(item.Value)
      )
      this.chartInstance = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.disasterAlertData.Forecast.Data.map((item) => item.Time),
          datasets: [
            {
              label: this.disasterAlertData.Title,
              data: this.disasterAlertData.Forecast.Data.map(
                (item) => item.Value
              ),
              backgroundColor: barColors,
              borderWidth: 1
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              enabled: false // 隱藏提示框
            }
          },
          scales: {
            x: {
              grid: {
                display: false,
                drawBorder: false
              },
              ticks: {
                color: '#616161',
                font: {
                  size: 12
                }
              }
            },
            y: {
              grid: {
                display: false,
                drawBorder: false
              },
              ticks: {
                display: false
              },
              afterFit: function (scaleInstance) {
                scaleInstance.width = 0
              }
            }
          },
          barPercentage: 1,
          categoryPercentage: 0.9,
          hover: {
            mode: null
          }
        }
      })
    }
  }
}
</script>
<style lang="sass" scoped>
::v-deep .el-dialog__header
    display: none

.disaster-dialog
    color: $mainFontColor
    z-index: 2002

    .disaster-dialog-header
        padding: 12px 16px

    .disaster-dialog__title
        font-size: 24px
        font-weight: bold
        margin-bottom: 8px

    .disaster-dialog__expired
        font-size: 20px
        font-weight: bold

    .disaster-dialog-body
        display: flex
        align-items: center
        justify-content: space-between
        padding: 0 24px
        .disaster-dialog__info
            width: 400px
            margin-right: 40px
            font-weight: normal !important

    .disaster-dialog__btn
        margin: 16px auto 0 auto
        display: block

.disaster-chart
    display: flex
    flex-direction: row
    width: 100%
    border-radius: 8px

    .chart-area
        flex: 1
        padding: 16px

        canvas
            width: 100% !important
            height: 100% !important
            min-height: 150px
            max-height: 150px

        .legend-area
            margin-top: 6px
            display: flex
            flex-direction: row
            justify-content: space-between
            align-items: center
            gap: 16px
            padding: 8px 0

            .legend-ticks
                display: flex
                flex-direction: column
                align-items: flex-start

                .legend-colors
                    display: flex
                    flex-direction: row
                    margin-bottom: 2px
                    .legend-color
                      position: relative
                      width: var(--legend-width)
                      height: 14px

                .legend-labels
                    display: flex
                    flex-direction: row
                    align-items: center
                    margin-top: 2px

                    .legend-label
                        font-size: 11px
                        color: #616161
                        min-width: var(--legend-width)
                        text-align: left

                    .legend-unit
                        font-size: 11px
                        color: #616161
                        margin-left: 2px
                        white-space: nowrap

            .legend-logo
                width: 40px
                height: 40px
                margin-bottom: 0
                position: static
                transform: none

    &__logo
        img
            width: 120px
            height: auto
            object-fit: contain
            display: block
.disaster-image
    border-radius: 20px
    padding: 10px 12px
    width: 420px
    box-sizing: border-box

    &-header
        padding: 14px 16px
        border-radius: 20px 20px 0 0
        background-color: #2C4F64
        color: $white
        display: flex
        line-height: 1.4

    &__title
        font-size: 24px
        font-weight: bold
        margin-bottom: 4px

    &__community
        font-size: 14px

    &__image
        border-radius: 100%
        width: 48px
        margin-right: 10px

    &-body
        padding: 14px 16px
        background-color: #F3F3F3
        border-radius: 0 0 20px 20px

    &__expired
        margin: 8px 0
        color: $grayFontColor
        font-size: 14px
</style>
